module.exports = __webpack_public_path__ + "src/assets/img/trygghansa.d5ba6a09.png";